import axios from 'axios';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import moment from 'moment';

import { getUSTimeFormat } from './dateUtils';

export const DownloadSafariBlob = async (url, assetName, setLoader) => {
  try {
    const result = await axios.get(url);
    console.log(result);
    var blob = new Blob([result.data]);
    saveAs(blob, assetName);
  } catch (error) {
    console.error('download not supported in browser!');
  } finally {
    setLoader(false);
  }
};

/**
 *
 * @param {Number} start - starting number of range
 * @param {Number} end - ending number of range
 * @param {Number} n - number of intervals required for the range
 * @returns {Array} - Range in array format
 */
export const rangeGenerator = (start, end, n) => {
  if (n < 2) {
    throw new Error('n must be at least 2.');
  }

  const step = (end - start) / (n - 1);

  const result = [];
  for (let i = 0; i < n; i++) {
    result.push(start + i * step);
  }

  return result;
};

export const SortOrder = {
  ascend: 'ascend',
  descend: 'descend'
};

/**
 *
 * @param {Array} array - array of objects to sort
 * @param {String} key - date key from object to sort with
 * @param {String} order - sort order; default is descend
 * @returns {Array} - sorted array
 */
export const sortArrayByDate = (
  array = [],
  key = '',
  order = SortOrder.descend
) => {
  if (order === SortOrder.ascend) {
    return array.sort((a, b) => {
      if (_.has(a, key) && _.has(b, key)) {
        return new moment.utc(a[key]) - new moment.utc(b[key]);
      }
    });
  }

  if (order === SortOrder.descend) {
    return array.sort((a, b) => {
      if (_.has(a, key) && _.has(b, key)) {
        return new moment.utc(b[key]) - new moment.utc(a[key]);
      }
    });
  }
};

export const truncateText = (value = '', length = 10) =>
  value.length > length ? `${value.slice(0, length)}...` : value;

export const getDateRange = (startDate = '', endDate = '') =>
  `${getUSTimeFormat(startDate)} - ${getUSTimeFormat(endDate)}`;

export const openLinkInNewTab = (event, link) => {
  event.preventDefault();
  if (!link) return;
  window.open(link, '_blank', 'noopener,noreferrer');
};

export const getFormattedAmount = amount => {
  if (amount === undefined || amount === null) return;

  const formattedAmount = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(amount);

  return formattedAmount;
};

export const getAngleValue = value =>
  value || value === 0 ? `${value}°` : 'N/A';

export const capitalizeText = (val = '') => {
  if (!val || val.length === 0) return '';
  if (val.length < 2) return val.toUpperCase();
  return val.charAt(0).toUpperCase() + val.substring(1).toLowerCase();
};

export const pluralize = n => {
  return n > 1 ? 's' : '';
};
